import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  content: {
    padding: "2.5rem",
  }
});
